import React, { useRef, useEffect, useState } from "react";
import {
  Typography,
  Table,
  TableBody,
  CardContent,
  TableHead,
  TableRow,
  Box,
  Grid,
  Button,
  TableContainer,
  Paper,
  Card,
  TableCell,
  Menu, MenuItem
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import { toPng } from "html-to-image";
import jsPDF from "jspdf";
import PrintIcon from '@mui/icons-material/Print';
import DownloadIcon from '@mui/icons-material/Download';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; 
import { useAuth } from "../../../AuthProvider";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { toast ,ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from "react-router-dom";


const baseUrl = process.env.REACT_APP_API_BASE_URL

const PurchaseReceiptDummy = () => {
  const componentRef = useRef();
  const location = useLocation();
  const scrollRef = useRef(null);
 
  const { billNo } = useParams(); 
  console.log("Received billNo:", billNo);

  const {soldItemData}=location.state || {}
  

const purchaseInvoice = location?.state?.purchaseInvoice;

  const [saleItems, setSaleItems] = useState([]); //TABLE API


  const navigate =useNavigate();

  // Handle Print
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "BillReceipt",
  }); 


  const { oId ,board} = useAuth();
 const [companyInfo, setCompanyInfo] = useState({
    schoolName: "",
    pincode: "",
    primaryContact: "",
    secondaryContact: "",
    boardAffiliation: "",
    schoolAddress: "",
    affiliationNumber: "",
    city: "",
    state: "",
    schoolEmailId: "",
    schoolLogo: "",
    schoolStamp: "",
  });
  const [tempInfo, setTempInfo] = useState({ ...companyInfo });
  const [orgloading, setOrgLoading] = useState(true); 

  const cellStyle = {
    border: "1px solid #ddd",
    padding: "4px 8px", // reduced top/bottom padding
    textAlign: "center",
    fontSize: "14px" // optionally reduce font size too
  };
  
  const cellHeaderStyle = {
    border: "1px solid #ddd",
    padding: "4px 8px", // reduced top/bottom padding
    textAlign: "center",
    fontSize: "14px", // match body font size
    backgroundColor: "#F9ADA4",
    fontWeight: "bold"
  };
  
  


  // Auto scroll to bottom when component mounts or updates
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, []);

 

  // Function to download the Quotation as PDF
  const handleDownload = () => {
    toPng(componentRef.current)
      .then((imgData) => {
        const pdf = new jsPDF();
        pdf.addImage(imgData, "PNG", 0, 0, 210, 297); // A4 size: 210x297mm
        pdf.save("BillReceipt.pdf");
      })
      .catch((error) => {
        console.error("Could not download Quotation:", error);
      });
  };





  //organization details api 
    useEffect(() => {
      const fetchCompanyInfo = async () => {
        try {
          const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          
  
          const data = await response.json();
          setCompanyInfo({
            schoolLogo: data.schoolLogo,
            schoolStamp:data.schoolStamp,
            schoolName: data.schoolName,
            city: data.city,
            state: data.state,
            affiliationNumber: data.affiliationNumber,
            schoolAddress: data.schoolAddress,
            primaryContact: data.primaryContact,
            boardAffiliation: data.boardAffiliation,
            secondaryContact: data.secondaryContact,
            pincode: data.pincode,
            schoolEmailId: data.schoolEmailId,
          });
          setTempInfo(data);
  
          setOrgLoading(false); // Data fetched, stop loading
  
        } catch (error) {
          console.error("Error fetching company info:", error);
          setOrgLoading(false); // Stop loading even if there's an error
        }
      };
  
      fetchCompanyInfo();
    }, []);



//  TABLE GET METHOD
const fetchTableData = async (purchaseInvoice, oId) => {
    if (!purchaseInvoice || !oId) {
      console.warn("Missing purchaseInvoice or organization ID (oId).");
      return;
    }

    try {
      const response = await fetch(
        `${baseUrl}/api/purchase/getAllItemsBasedOnInvoice/${purchaseInvoice}/${oId}`
      );

      if (!response.ok) {
        console.error("Failed to fetch table data:", response.statusText);
        return;
      }

      const data = await response.json();
      setSaleItems(data);
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  useEffect(() => {
    console.log("Triggered useEffect");
    console.log("purchaseInvoice:", purchaseInvoice);
    console.log("oId:", oId);

    if (purchaseInvoice && oId) {
      fetchTableData(purchaseInvoice, oId);
    }
  }, [purchaseInvoice, oId]);




 
  function convertNumberToWords(num) {
    const words = [
      "Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
      "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen",
      "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];
  
    if (num === 0) return words[0];
  
    function convertHundreds(n) {
      let result = "";
      if (n > 99) {
        result += words[Math.floor(n / 100)] + " Hundred ";
        n %= 100;
      }
      if (n > 19) {
        result += words[20 + Math.floor(n / 10) - 2] + (n % 10 !== 0 ? " " + words[n % 10] : "");
      } else if (n > 0) {
        result += words[n];
      }
      return result.trim();
    }
  
    function convertThousands(n) {
      if (n >= 1000) {
        return convertHundreds(Math.floor(n / 1000)) + " Thousand " + convertHundreds(n % 1000);
      } else {
        return convertHundreds(n);
      }
    }
  
    let integerPart = Math.floor(num); // Integer part of the number
    let decimalPart = Math.round((num - integerPart) * 100); // Fractional part (up to 2 decimal places)
  
    let result = "";
  
    // Process Crore
    if (integerPart >= 1e7) {
      result += convertThousands(Math.floor(integerPart / 1e7)) + " Crore ";
      integerPart %= 1e7;
    }
  
    // Process Lakh
    if (integerPart >= 1e5) {
      result += convertThousands(Math.floor(integerPart / 1e5)) + " Lakh ";
      integerPart %= 1e5;
    }
  
    // Process Thousand
    if (integerPart >= 1000) {
      result += convertThousands(Math.floor(integerPart / 1000)) + " Thousand ";
      integerPart %= 1000;
    }
  
    // Process Remaining Hundreds, Tens, and Ones
    if (integerPart > 0) {
      result += convertHundreds(integerPart);
    }
  
    // Handle decimal part if it exists
    if (decimalPart > 0) {
      result += " and " + convertHundreds(decimalPart) + " Paise";
    }
  
    return result.trim();
  }
  
  
  

  return (
    <Grid
      container
      marginTop={"70px"}
      // marginLeft={"10px"}
      marginRight={"20px"}
      // spacing={2} // Optional: To manage spacing between grid items
      sx={{ // You can also use sx if you're using Material UI v5 or later for styling
        display: 'flex', // Ensure flex behavior
        justifyContent: 'center', // Example: Center content if needed
        padding: '0', // Ensure no additional padding is applied to the container
        boxSizing: 'border-box',
      }}
    >
      {/* Left Side: Quotation Section */}
      <Grid item xs={12}>
        <Box>

        <Card
        sx={{
          position: 'sticky',
          // top: 0,
          // zIndex: 10,
          width: '100%', // Ensures full width
          maxWidth: '100%', // Avoids exceeding the screen width
          padding: '16px',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
          marginBottom: '20px',
          boxSizing: 'border-box', // Ensures padding is included in width
        }}
      >
        {/* Quotation Details */}
        <Box display="flex"  sx={{ marginBottom: '20px' }}>
          <ArrowBackIcon
            sx={{
              color: '#1976d2',
              marginRight: '8px',
              marginTop:'7px',
              cursor:'pointer'
            }}
            onClick={ () => navigate(-1)}
          />
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              fontSize: '20px',
              color: '#333',
            }}
          >
           {soldItemData?.purchaseCompanyName || "N/A"} / Invoice No #{soldItemData?.purchaseInvoice || "N/A"}

          </Typography>
        </Box>

        {/* Buttons Section */}
        <Box display="flex" alignItems="center">
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            {/* Print Button */}
            <Button
              onClick={handlePrint}
              variant="contained"
              startIcon={<PrintIcon />}
              sx={{
                backgroundColor: '#1976d2',
                color: '#fff',
                fontSize: '11px',
                fontWeight: 'bold',
                padding: '8px 18px',
                borderRadius: '8px',
                boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
                transition: 'transform 0.2s, background-color 0.3s',
                '&:hover': {
                  backgroundColor: '#1565c0',
                  transform: 'translateY(-3px)',
                },
              }}
            >
              Print Receipt
            </Button>

            {/* Download Button */}
            <Button
              onClick={handleDownload}
              variant="contained"
              startIcon={<DownloadIcon />}
              sx={{
                backgroundColor: '#e53935',
                color: '#fff',
                fontSize: '11px',
                fontWeight: 'bold',
                padding: '8px 18px',
                borderRadius: '8px',
                boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
                transition: 'transform 0.2s, background-color 0.3s',
                '&:hover': {
                  backgroundColor: '#d32f2f',
                  transform: 'translateY(-3px)',
                },
              }}
            >
              Download Receipt
            </Button>

          
          </div>
        </Box>
       
      </Card>
      <ToastContainer />



          {/* The layout for the Quotation */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              ref={componentRef}
              sx={{
                width: "210mm", // A4 width
                height: "297mm", // A4 height
                padding: "20px",

                boxSizing: "border-box",
                backgroundColor: "white", // Default background for the Quotation
                overflow: "hidden", // To ensure the scroll container handles overflow
                "@media print": {
                  size: "A4",
                  margin: "0",
                  padding: "10",
                },
              }}
            >
             <Typography
              sx={{
                paddingBottom: "15px",
                fontWeight: "bold",
                fontFamily: "Arial, sans-serif",
                fontSize: "15px", // Optional: Adjust font size
                color: "#333", // Optional: Adjust font color
                textAlign:'center'
              }}
              >
              Bill Receipt
            </Typography>
              {/* Scrollable content */}
              <Box
                ref={scrollRef}
                sx={{
                  maxHeight: "100%", // Ensure container height doesn't exceed the page
                  paddingRight: "6px",
                }}
              >
                {/* Header */}
                <CardContent>
                        <Grid container spacing={2} alignItems="center" justifyContent="space-between" mb={0}>
                          {/* Left and Center Section */}
                          <Grid item xs={12} sm={8}>
                            <Grid container spacing={2} alignItems="center">
                              {/* Logo */}
                              <Grid item xs={12} sm={4} style={{ display: "flex", justifyContent: "center" }}>
                                <img
                                  src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
                                  alt="Logo"
                                  style={{
                                    width: "120px",
                                    height: "130px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                              </Grid>

                              {/* Company Info */}
                              <Grid item xs={12} sm={8}>
                                <Grid container direction="column" spacing={1}>
                                  <Grid item>
                                    <Typography variant="h4" style={{ fontWeight: "bold", color: "red" }}>
                                      {companyInfo.schoolName}
                                    </Typography>
                                  </Grid>

                                  <Grid item>
                                    <Typography>
                                      {[companyInfo.schoolAddress, companyInfo.city].filter(Boolean).join(', ')}
                                      <br />
                                      {[companyInfo.state, companyInfo.pincode].filter(Boolean).join(', ')}
                                    </Typography>
                                  </Grid>


                                  <Grid item>
                                    <Typography style={{ fontWeight: "bold" }}>
                                      Email: <span style={{ fontWeight: "normal" }}>{companyInfo.schoolEmailId}</span>
                                    </Typography>
                                  </Grid>

                                  <Grid item>
                                    <Typography style={{ fontWeight: "bold" }}>
                                      Contact: <span style={{ fontWeight: "normal" }}>{companyInfo.primaryContact}</span>
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          

                          {/* Right Section - Quotation */}
                          <Grid item xs={12} sm={4}>
                            <Typography
                              variant="h5"
                              style={{
                                fontWeight: "bold",
                                textAlign: "left",
                                paddingLeft: "10px",
                                marginBottom: "5px",
                              }}
                            >
                              Bill Details:
                            </Typography>

                            <Grid container direction="column" spacing={1} style={{ paddingLeft: "10px" }}>
                              <Grid item>
                              <Grid container justifyContent="space-between" alignItems="center">
                                <Grid item>
                                  <Typography variant="body1">
                                    <strong>Purchase Inovice:</strong>
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Typography variant="body1">
                                    {soldItemData?.purchaseInvoice}
                                  </Typography>
                                </Grid>
                              </Grid>

                              </Grid>

                              <Grid item>
                              <Grid container justifyContent="space-between" alignItems="center">
                              <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ width: '100%' }}>
                                <Typography variant="body1" style={{ flex: 1 }}>
                                  <strong>Purchase Date:</strong>
                                </Typography>
                                <Typography variant="body1" style={{ flex: 1, textAlign: "right" }}>
                                  {soldItemData?.purchaseDate}
                                </Typography>
                              </Grid>

                        </Grid>

                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Typography variant="h6" style={{ fontWeight: "bold", marginTop: 16, marginBottom: 8 }}>
                          Company Details: 
                        </Typography>
                        {/* First Row: Student Id and Student Name */}
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={{ display: "flex", alignItems: "center" }}>
                        <Box component="span" sx={{ fontWeight: "bold", minWidth: "120px" }}>Company Name:</Box>
                        <Box component="span">{soldItemData?.purchaseCompanyName || "-"}</Box>
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography sx={{ display: "flex", alignItems: "center" }}>
                        <Box component="span" sx={{ fontWeight: "bold", minWidth: "120px" }}>Company Address:</Box>
                        <Box component="span">{`${soldItemData?.studentFirstName || ""} ${soldItemData?.purchaseCompanyAddress || ""}`}</Box>
                      </Typography>
                    </Grid>

                    {/* {board === "INTERMEDIATE" && (
                      <Grid item xs={12} sm={6}>
                        <Typography sx={{ display: "flex", alignItems: "center" }}>
                          <Box component="span" sx={{ fontWeight: "bold", minWidth: "120px" }}>Course:</Box>
                          <Box component="span">{soldItemData?.course || "-"}</Box>
                        </Typography>
                      </Grid>
                    )} */}

                    {/* <Grid item xs={12} sm={6}>
                      <Typography sx={{ display: "flex", alignItems: "center" }}>
                        <Box component="span" sx={{ fontWeight: "bold", minWidth: "120px" }}>
                          {board === "INTERMEDIATE" ? "Year:" : "Class:"}
                        </Box>
                        <Box component="span">{soldItemData?.romanNumberClass || "-"}</Box>
                      </Typography>
                    </Grid> */}

                    {/* <Grid item xs={12} sm={6}>
                      <Typography sx={{ display: "flex", alignItems: "center" }}>
                        <Box component="span" sx={{ fontWeight: "bold", minWidth: "120px" }}>Section:</Box>
                        <Box component="span">{soldItemData?.sections || "-"}</Box>
                      </Typography>
                    </Grid> */}
                  </Grid>



                </CardContent>

              

                {/* Table of Items */}
        <TableContainer component={Paper} sx={{ width: '100%' }}>
  <Table sx={{ width: '100%' }}>
    <TableHead sx={{ backgroundColor: "#F9ADA4", height: "28px" }}>
      <TableRow>
        <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px", fontSize: "14px", backgroundColor: "#F9ADA4", fontWeight: "bold" }}>
          S.No
        </TableCell>
        <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px", fontSize: "14px", backgroundColor: "#F9ADA4", fontWeight: "bold" }}>
          ITEMS
        </TableCell>
        <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px", fontSize: "14px", backgroundColor: "#F9ADA4", fontWeight: "bold" }}>
          QTY
        </TableCell>
        <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px", fontSize: "14px", backgroundColor: "#F9ADA4", fontWeight: "bold" }}>
          RATE
        </TableCell>
        <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px", fontSize: "14px", backgroundColor: "#F9ADA4", fontWeight: "bold" }}>
          AMOUNT
        </TableCell>
      </TableRow>
    </TableHead>

   <TableBody>
  {saleItems?.map((item, index) => (
    <TableRow key={item.pId || index}>
      <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>
        {index + 1}
      </TableCell>
      <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>
        {item.items}
      </TableCell>
      <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>
        {item.qty}
      </TableCell>
      <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>
        ₹{item.priceItem}
      </TableCell>
      <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>
        ₹{item.purchaseAmount}
      </TableCell>
    </TableRow>
  ))}

  {/* SUBTOTAL Row */}
  <TableRow>
    <TableCell
      colSpan={4}
      sx={{
        padding: "2px",
        textAlign: "center",
        fontSize: "14px",
        fontWeight: "bold",
        backgroundColor: "#F9ADA4",
        border: "1px solid #ddd"
      }}
    >
      SUBTOTAL
    </TableCell>
    <TableCell
      sx={{
        border: "1px solid #ddd",
        padding: "2px",
        textAlign: "center",
        fontSize: "14px",
        fontWeight: "bold",
        backgroundColor: "#F9ADA4"
      }}
    >
      ₹{saleItems?.reduce((sum, item) => sum + (item.purchaseAmount || 0), 0)}
    </TableCell>
  </TableRow>
</TableBody>

  </Table>
</TableContainer>



                {/*  Total  Amount */}
                <Grid container justifyContent="flex-end" spacing={2} style={{ marginTop: '3px' }}>
  <Grid item xs={12} md={6}>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography variant="h5" style={{ fontWeight: "bold" }}>
        TOTAL AMOUNT
      </Typography>
      <Typography variant="h5" style={{ fontWeight: "bold" }}>
        ₹{soldItemData?.purchaseAmount}
      </Typography>
    </div>
    <hr
      style={{
        border: "none",
        borderTop: "1px solid black",
        marginTop: "10px",
      }}
    />
 

  </Grid>
</Grid>


                {/* Footer */}
                <Grid container justifyContent="space-between" alignItems="flex-start" style={{ marginTop: "20px" }}>
  {/* Left: Total Amount in Words (same height as image, content aligned to top) */}
  <Grid item>
  <Box
    sx={{
      // height: "130px",
      display: "flex",
      alignItems: "center"
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: "normal" }}>
      Total Amount (in words):{" "}
      <Box component="span" sx={{ fontWeight: "bold", pl: 1 }}>
        {convertNumberToWords(soldItemData?.purchaseAmount)}
      </Box>
    </Typography>
  </Box>
</Grid>



  {/* Right: Stamp and Signature */}
  <Grid item textAlign="right">
    <img
      src={`data:image/jpeg;base64,${companyInfo.schoolStamp}`}
      alt="Logo"
      style={{ width: "120px", height: "130px", marginRight: "60px", borderRadius: "50%" }}
    />
    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
      Authorized Stamp for {companyInfo?.schoolName}
    </Typography>
  </Grid>
</Grid>


              </Box>{" "}
              {/* End Scrollable Box */}
            </Box>
          </div>
        </Box>
      </Grid>

    </Grid>
  );
};

export default PurchaseReceiptDummy;